export const CATEGORY_ID = {
	NEMOVITOSTI: 77,
	SLUZBY: 82,
	ZVIRATA: 90,
	PSI: 91,
	METALWORKING_MACHINES: 231, // special for SSP adverts
};

export const ANIMAL_WARNING_CATEGORY_IDS = [CATEGORY_ID.PSI, CATEGORY_ID.ZVIRATA];
